export default "__VITE_ASSET__26c299b9__"